var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAliviaA({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E9ECEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6984_12093",
    transform: "translate(-0.005) scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6984_12093",
    width: 101,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABkCAYAAACfIP5qAAAAAXNSR0IArs4c6QAABQFJREFUeJztnD9rG0kYh38rrey1HLIqDDHYJweucBGCD65wYZEP4JD0+gYCXy9wf3ByfSEurwhy74PrD+QicIVNUlzgApYcgwJXSBDbK2m9usIeIev0Z2a1s/vu8j7gwmJHWu2j38zsOyMZ/X6/D4YSv6WiPgPm/7AUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgrAUgsRSyi/nHbTd5G7sjJ2UhuPhoN7F4Zdu1KeijdhJqZx3AACHl73EpiVWUj58u8XRVxcA0Hb7iU1LrKTs/9N58H9S0xIbKdVmDyft2wePJTUtsZFSqXfGPp7EtMRCSrXZw4Uz/sInMS2xkDIpJYLDyx4aE6TFEfJSpqVE0Hb7M8XFCdJSGo4nfbGPmslJC2kpMikZZu/TjcazCQ+yUhqOh6OvPaU2J61b1Fq3sw8kDlkplfOOUkoG7RIwtpCUcpcS11fbJKSFpBRRdPTdPuZpISdlnpQI4p4WM+oTGGXelAyep95BIZedekzD8VBrubDNFOz7K2GbxoO/KCAlpdZy506JQKSlkEtPPMY2DRzUuzPvbx6bBuw0YGcM2Glj0NY2DeyumHi5EuxlNCj9YM6Lv67w8coL7Pm+s1I4216eesxRs4e9T46v589bKRxvZZG3Ak0UnR/MqTZ70kJku5ULx0O1Of1ep7ia8X1RyxsLQQsBQGigl50x2aaB462stJhKfXoFudZy8djH2FFczaC4mlFuJwMJKSrllNL6Ap4/SqG0JndBLhwPb8eU9mstF69Or/H67AYfv6l1mXkrhfLGolIbFUhIkU1J3kqh+ORORml9QTotB/XuYCFsWMboSqYsurotQeSzL5WUDF8M2zRQWsvM7J6Au9L+/ucOGjeebxECnd2WINLZV8Px8OrsWkpK3krhdGQm1Xb7+OH9VWjLwZpmW6NEO/tSTckoIi1hobvbEkQmRex0lCFvpSZ2GSpjyzy8XDG1d1uCyKSolFPGpUQQRlps08DP31taX2OYSKSoFB0LufTUT2it5QZWfLRNA+Wni3j3bOnB4+Wni6F0W4JIZl9qKRl/P1Bruaicd+eeTQH3aVtfQGktM+gKd3JpnNzXzsIct4AIpKikpLiawc5IQVG3DEF5YxGvW9f4dXNpQmt9hC7Fb0qClAEAuysm3mxaEycJhVwa754thdptCUKVolKaF4XCoGUIPkiUVnYDLsnLEupAr1Ii37HTc5dDpnHheGS3u4Z2R19t9vCTz3ULXdimgdPt5chWGCcQ3h19mJsZnj+Se1tUN4eHIkV1p6NfCrk0ft/K4s8fl6UHaIpfpQhFiu6UCBnHW9nBFFp2vYNiWrRLefulqy0l42QIVJZ5qaVFq5SG4+HwMvhP4TQZw8Q1LVqlBD2WyMoQjKsITIJSWrRJUSnNz0JVxjBxTIs2KUHsdMxbKbzZtHzJEBRyaaW0UPjikRYp8+4HFjJOt5cDWVhSSQuFzeFapPhNSdAyBCppofA1vcCl+EmJLhnDqOzT2v8cbTkocCl7f8u/oTBkCFTS8se/wa1m+oHUBm8GQNRbjJjxsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSCsBSC/AfbukJJYJzKNAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliviaA);
export default __webpack_public_path__ + "static/media/aliviaA.535fcdbec0c37289987d7f75ffa56b58.svg";
export { ForwardRef as ReactComponent };